/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSkillRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'
import {GetSkillResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'


export const getSkill = (request: GetSkillRequest, options?: CashRequestOptions) => post<GetSkillRequest, GetSkillResponse>("/2.0/cash/get-skill", request, {...options, rejectOnError: true })